import { Tag } from 'antd';
import { EditOutlined, PlusCircleOutlined, DeleteOutlined, SyncOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import React from 'react';
import UserAvatar from '@app/components/common/UserAvatar/UserAvatar';
import './ActivityHistory.css';
import { DATE_FORMAT } from '@app/constants/dateFormats';

const ACTION_CONFIG: Record<string, { color: string; icon: React.ReactNode; label: string }> = {
  create:        { color: '#52c41a', icon: <PlusCircleOutlined />, label: 'Tạo mới' },
  update:        { color: '#004c4c', icon: <EditOutlined />,       label: 'Cập nhật' },
  update_status: { color: '#722ed1', icon: <SyncOutlined />,       label: 'Đổi trạng thái' },
  delete:        { color: '#ff4d4f', icon: <DeleteOutlined />,     label: 'Xoá' },
};

const getActionConfig = (action: string) =>
  ACTION_CONFIG[action?.toLowerCase()] ?? { color: '#8c8c8c', icon: <EditOutlined />, label: action };

const formatValue = (value: any): React.ReactNode => {
  if (value === null || value === undefined || value === '')
    return <span className="activity-value-null">—</span>;
  if (typeof value === 'boolean')
    return <Tag color={value ? 'success' : 'default'}>{value ? 'true' : 'false'}</Tag>;
  if (typeof value === 'object')
    return <pre className="activity-value-pre">{JSON.stringify(value, null, 2)}</pre>;
  return String(value);
};

export const getDefaultColumns = () => [
  {
    title: '',
    dataIndex: 'avatar',
    key: 'avatar',
    width: 48,
    render: (_: any, record: any) => <UserAvatar name={record.created_by} avatarUrl={record.created_by_avatar_url} size={32} showName={false} />,
  },
  {
    title: 'Hành động',
    dataIndex: 'action',
    key: 'action',
    width: 130,
    render: (action: string) => {
      const cfg = getActionConfig(action);
      return (
        <Tag
          icon={cfg.icon}
          className="activity-action-tag"
          style={{ color: cfg.color, borderColor: cfg.color, background: `${cfg.color}10` }}
        >
          {cfg.label}
        </Tag>
      );
    },
  },
  {
    title: 'Nội dung',
    dataIndex: 'comment',
    key: 'comment',
    width: 160,
    render: (text: string) => (
      <span className="activity-comment">{text || '—'}</span>
    ),
  },
  {
    title: 'Thay đổi',
    dataIndex: 'audited_changes',
    key: 'changes',
    render: (changes: Record<string, [any, any]>) => {
      if (!changes || Object.keys(changes).length === 0)
        return <span className="activity-no-changes">Không có thay đổi</span>;

      return (
        <div className="activity-changes">
          {Object.entries(changes).map(([field, vals]) => {
            const [from, to] = vals as [any, any];
            return (
              <div key={field} className="activity-change-row">
                <span className="activity-change-field">{field}</span>
                <span className="activity-change-from">{formatValue(from)}</span>
                <span className="activity-change-arrow">→</span>
                <span className="activity-change-to">{formatValue(to)}</span>
              </div>
            );
          })}
        </div>
      );
    },
  },
  {
    title: 'Thời gian',
    dataIndex: 'created_at',
    key: 'created_at',
    width: 110,
    render: (date: string) => (
      <div className="activity-date">
        <div className="activity-date-day">{dayjs(date).format(DATE_FORMAT)}</div>
        <div className="activity-date-time">{dayjs(date).format('HH:mm')}</div>
      </div>
    ),
  },
];
